import React from 'react'
import { AvailableClinic, Block } from '@components'

const DatoCmsAvailableClinic = ({
  paddingTop,
  paddingBottom,
  backgroundColour,
  ...props
}) => {
  return (
    <Block
      gutters
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      backgroundColour={backgroundColour}
    >
      <AvailableClinic {...props} />
    </Block>
  )
}

export default DatoCmsAvailableClinic
